import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Component({selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrls: ['./report-header.component.scss'],
  standalone: false,
})
export class ReportHeaderComponent implements OnInit {
  /** Title */
  @Input() title: string;

  /** Image svg pah when use svg icon */
  @Input() imageSvgPath: string;

  /** Icon class */
  @Input() iconClass: string;

  /** Use search */
  @Input() showSearch: boolean = true;

  /** Show menu */
  @Input() showMenu: boolean = true;

  /** Panel style */
  @Input() style: any;

  /** When menu item click emit output  */
  @Output() onMenuItemAction = new EventEmitter<any>();

  /** Om search input emit output */
  @Output() searchOnInput = new EventEmitter<any>();

  /** Items list */
  items: MenuItem[];

  private destroyRef = inject(DestroyRef);

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.initItems();
    // YB-2274 — instant() returns the bare key before the user's language has loaded (a refresh), so
    // the menu is built again once it lands, and on every language switch.
    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.initItems());
  }

  /**
   * Init menu items
   */
  initItems() {
    this.items = [
      {
        label: this.translate.instant('REPORTS.TITLE.PRINT_REPORT'),
        icon: 'pi pi-print fz-14 color-primary',
        iconStyle: { color: 'var(--primary-color)' },
        command: () => {
          this.onMenuItemAction.emit('print');
        },
      },
    ];
  }

  /**
   * Export report button on click take the last selected menu item and emit output
   * @param e
   */
  exportReportOnClick(e: any) {
    if (e) this.onMenuItemAction.emit(e);
  }
}
